import { Component, OnInit, Input, Inject, ViewChild } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { LoaderService } from '../../shared/loader/loader.service';

@Component({
  selector: 'app-importReferralLocation',
  templateUrl: './importReferralLocation.component.html',
  styleUrls: ['./importReferralLocation.component.scss']
})

export class ImportReferralLocationComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any = [];
  myOfficeID: any;
  spinner: boolean = false;
  ShowNoRecordFoundQuestionTemplate: boolean = false;
  currentIndex: number = 0;
  locationList: any = [] = [];
  locationID: number = 0;
  referralID: number = 0;

  constructor(private dialog: MatDialog, private dialog1: MatDialog, private datePipe: DatePipe, public dialogRef: MatDialogRef<ImportReferralLocationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService, private loaderService: LoaderService,) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }
  }

  ngOnInit(): void {
    this.referralID=this.data.referralID;
    this.getActiveReferralLocations();
  }

  getActiveReferralLocations() {
    const reqModel = {
      LocationName: "",
      // [head-internal] the head office picks from the locations of the referral's own office
      ReferralID: Number(this.referralID || 0),
      UserID: this.currentUser.UID,
      OfficeID: this.myOfficeID,
      OrganizationID: Number(this.organizationId),
      DatabaseID: Number(this.databaseId)
    };
    this.loaderService.show();
    this.coreService.getActiveReferralLocations(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.locationList = response.data;          
          if (this.locationList.length > 0) {
            this.ShowNoRecordFoundQuestionTemplate = false;
          } else {
            this.ShowNoRecordFoundQuestionTemplate = true;
          }
        } else {
          this.locationList = [];         
          this.loaderService.hide();
        }
      } else {
        this.locationList = [];        
        this.loaderService.hide();
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }


  SelectTemplateQuestionTempForImport(data) {
    this.locationID = data.locationID;
  }

  AssociateLocationWithReferralQueue() {
    const reqModel = {
      referralID: this.referralID,
      locationID:this.locationID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    };
    this.loaderService.show();
    this.coreService.associateLocationWithReferralQueue(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Location added successfully.', '', {
            timeOut: 3000,
          });
          this.dialogRef.close('Added');
        } else {
          this.loaderService.hide();
        }
      } else {        
        this.loaderService.hide();
      }
    });
  }


}
